import React from "react";
import { createPortal } from "react-dom";
import type { TFunction } from "i18next";
import { ChevronLeft } from "lucide-react";
import { useWidgetTopBar } from "../context/WidgetTopBarContext";
import { LINK_BUTTON } from "../buttons/linkButtonClassNames";

interface BookingBackButtonProps {
  readonly onClick: () => void;
  readonly disabled?: boolean;
  readonly t: TFunction;
}

/**
 * The journey's step back control. In the widget it renders into the top bar's
 * slot, beside the expand/shrink control, so it sits on that control's line
 * whatever padding the journey gives the stage; everywhere else it stays at the
 * top of the step. Either way it is the step's first control, so keyboard and
 * screen reader order follow the visual order.
 */
const BookingBackButton: React.FC<BookingBackButtonProps> = ({ onClick, disabled = false, t }) => {
  const topBarSlot = useWidgetTopBar();

  const button = (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`booking-form-back-button gcw:self-start gcw:disabled:opacity-50 gcw:disabled:cursor-not-allowed ${LINK_BUTTON}`}
      aria-label={t("booking_back", "Back")}
    >
      <ChevronLeft size={18} aria-hidden="true" />
      {t("booking_back", "Back")}
    </button>
  );

  return topBarSlot ? createPortal(button, topBarSlot) : button;
};

export default BookingBackButton;
